/**
 * HTML5 / browser / Tizen web shells with durable IndexedDB offline cache.
 * Omit `offline_cache` / `cmd_clear_cache` only when the shell cannot provide
 * a durable AssetStore + OfflineStateStore.
 */
export const WEB_PLAYER_CAPABILITIES = [
    'offline_cache',
    'schedule_eval',
    'cmd_sync_now',
    'cmd_clear_cache',
];
/** Same durable surface as web when running the shared core inside a Tizen shell. */
export const TIZEN_PLAYER_CAPABILITIES = WEB_PLAYER_CAPABILITIES;
/**
 * Ephemeral / test shells that only keep assets in memory for the session.
 * Do not claim offline_cache — cold start cannot resume playback.
 */
export const EPHEMERAL_WEB_PLAYER_CAPABILITIES = [
    'schedule_eval',
    'cmd_sync_now',
];
export function buildSurfaceIdentity(input) {
    const defaults = input.platform === 'tizen' ? TIZEN_PLAYER_CAPABILITIES : WEB_PLAYER_CAPABILITIES;
    return {
        platform: input.platform,
        playerBuild: `${input.platform}-${input.appVersion}`,
        capabilities: [...(input.capabilities ?? defaults)],
        ...(input.manufacturer ? { manufacturer: input.manufacturer } : {}),
        ...(input.model ? { model: input.model } : {}),
    };
}
//# sourceMappingURL=surface.js.map